import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Spacing16 } from 'autogen/design-tokens/tokens';
import { SearchInputText } from 'autogen/translation-keys/trans-website-filter';
import Icon from 'components/Icon';
import { TextInput } from 'components/shared/inputs/text';
import { useSearchQuery } from './shared/hooks/useFilterOptionsBySearchQuery';

/* #region styles */
const Container = styled.div`
    padding: ${Spacing16};
`;

const StyledTextInput = styled(TextInput)`
    width: 100%;
`;

/* #endregion */

export default function SearchInput() {
    const [searchQuery, setSearchQuery] = useSearchQuery();
    const { t } = useTranslation();

    return (
        <Container>
            <StyledTextInput
                value={searchQuery}
                onChange={(event) => setSearchQuery(event.target.value)}
                placeholder={t(SearchInputText)}
                rightIcon={<Icon type="Search" size={16} />}
            />
        </Container>
    );
}
